import React from 'react';
import { WizardContext } from '@buyside/components/presentation/Form/Wizard/Wizard';

const WizardPage: React.FunctionComponent<{
  children?: (ctx: { page: number; totalPages: number }) => React.ReactElement;
}> = ({ children }): React.ReactElement => {
  if (children && typeof children === 'function') {
    return (
      <WizardContext.Consumer>
        {({ page, totalPages }): React.ReactElement => children({ page, totalPages })}
      </WizardContext.Consumer>
    );
  }
  return (
    <WizardContext.Consumer>
      {({ page, totalPages }): React.ReactElement => (
        <div>
          Page {page + 1} out of {totalPages + 1}
        </div>
      )}
    </WizardContext.Consumer>
  );
};

export default WizardPage;
